import { render } from "./ShowInvoiceDetails.vue?vue&type=template&id=113fcb58"
import script from "./ShowInvoiceDetails.vue?vue&type=script&lang=js"
export * from "./ShowInvoiceDetails.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/var/www/duo_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__